module.exports = __webpack_public_path__ + "f576ad2bf866038ba1f96a57b59e12e7.svg";